import { MOBILE_BREAKPOINT, IS_IE9, ResizeThrottler } from './utils';

// Note: These will become imports when we get done with the current Gulp setup
const { InfiniteScroll, Isotope } = window;
const resizeThrottler = new ResizeThrottler();

class InfiniteScrollSection {
  constructor(elem) {
    this.dom = elem;
    this.itemsWrapper = elem.querySelector('.infinite-scroll__item-wrapper');
    this.startingPage = this.itemsWrapper.getAttribute('data-starting-page');
    this.craftRequestUrl = this.itemsWrapper.getAttribute('data-craft-request-url');
    this.isotope = null;

    // Set up view buttons if we're in the News view
    this.manageView = !!document.querySelector('.entry-filter__view');
    this.view = elem.classList.contains('news--grid') ? 'grid' : 'list';
    if (this.manageView) {
      this.listViewToggle = document.querySelector('#list-view-toggle');
      this.gridViewToggle = document.querySelector('#grid-view-toggle');
      this.listViewToggle.addEventListener('click', () => {
        this.handleViewClick('list');
      });
      this.gridViewToggle.addEventListener('click', () => {
        this.handleViewClick('grid');
      });
      this.updateView();
    }

    // Begin!
    this.initInfiniteScroll();
    resizeThrottler.add(() => this.updateIsotope());
  }

  handleViewClick(gridOrList) {
    if (this.view === gridOrList) return false;
    if (this.view === 'grid') this.view = 'list';
    else this.view = 'grid';
    return this.updateView();
  }

  updateView() {
    if (this.view === 'grid') {
      // Switch to grid view
      this.dom.classList.remove('news--list');
      this.dom.classList.add('news--grid');
      this.listViewToggle.classList.remove('active');
      this.gridViewToggle.classList.add('active');
    } else {
      // Switch to list view
      this.dom.classList.remove('news--grid');
      this.dom.classList.add('news--list');
      this.gridViewToggle.classList.remove('active');
      this.listViewToggle.classList.add('active');
    }
    this.updateIsotope();
  }

  updateIsotope() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (this.view === 'grid' && windowWidth >= MOBILE_BREAKPOINT && !this.isotope) {
      // Init isotope
      this.isotope = new Isotope(this.itemsWrapper, {
        itemSelector: '.news-item',
        masonry: { gutter: 20 },
      });
    } else if ((this.view === 'list' || windowWidth < MOBILE_BREAKPOINT) && this.isotope) {
      // Kill isotope if we're switching to list view or mobile
      this.isotope.destroy();
      this.isotope = null;
    }
  }

  initInfiniteScroll() {
    if (IS_IE9) {
      // We can't infinite scroll, so just change the button to be more explicit
      const loadMoreText = this.dom.querySelector('.infinite-scroll__message--load-more-button a .btn__text');
      if (loadMoreText) loadMoreText.textContent = 'Next page';
    } else {
      const { craftRequestUrl, startingPage } = this;
      // Initialize infinite scroll
      const options = {
        path() {
          // Path is included manually here because InfiniteScroll chokes on query params
          const nextPageNum = (this.pageIndex + parseInt(startingPage, 10));
          const pageNum = `p${nextPageNum}${window.location.search}`;

          if (craftRequestUrl == window.location.origin + '/'){
            return `${craftRequestUrl}${pageNum}`;
          }

          return `${craftRequestUrl}${pageNum}`;
        },
        append: '.infinite-scroll__item-wrapper > *',
        checkLastPage: '.infinite-scroll__message--load-more-button a',
        scrollThreshold: false,
        debug: true,
      };
      this.infiniteScroll = new InfiniteScroll(this.itemsWrapper, options);

      // Attach our event listeners for infinite scroll
      const loadMoreButton = this.dom.querySelector('.infinite-scroll__message--load-more-button a');
      if (loadMoreButton) {
        this.dom.querySelector('.infinite-scroll__message--load-more-button a').addEventListener('click', (e) => {
          e.preventDefault();
          this.doInfiniteScroll();
          this.dom.querySelector('.infinite-scroll__message--load-more-button').style.display = 'none';
          this.dom.querySelector('.infinite-scroll__message--infinite-scroll-request').style.display = 'block';
        });
      }
      this.infiniteScroll.on('load', () => {
        this.dom.querySelector('.infinite-scroll__message--infinite-scroll-request').style.display = 'none';
      });
      this.infiniteScroll.on('last', () => {
        this.dom.querySelector('.infinite-scroll__message--infinite-scroll-last').style.display = 'block';
        this.dom.querySelector('.infinite-scroll__message--load-more-button').style.display = 'none';
      });
      this.infiniteScroll.on('append', (response, path, items) => {
        if (this.isotope) {
          // Trigger isotope to re-layout masonry
          this.isotope.appended(items);
          this.isotope.layout();
        }
        const nextLoadMoreButton = response.querySelector('.infinite-scroll__message--load-more-button a');
        if (nextLoadMoreButton) {
          const nextUrl = nextLoadMoreButton.getAttribute('href');
          this.dom.querySelector('.infinite-scroll__message--load-more-button a')
            .setAttribute('href', nextUrl);
          if (this.infiniteScroll.canLoad) {
            this.dom.querySelector('.infinite-scroll__message--load-more-button').style.display = 'block';
          }
        }
      });
    }
  }

  doInfiniteScroll() {
    if (!this.infiniteScroll) this.initInfiniteScroll();
    this.infiniteScroll.loadNextPage();
  }
}

function initInfiniteScrollSections() {
  [...document.querySelectorAll('.infinite-scroll')]
    .map(el => new InfiniteScrollSection(el));
}

export default initInfiniteScrollSections;
